import RangeFilter from './RangeFilter';

export default RangeFilter;
